'use strict';

module.exports.post = require('../src/optimize');
module.exports.gsd = require('../src/gsd');



// WEBPACK FOOTER //
// ./node_modules/ml-gsd/src/index.js